// A token read may outlive logout, an account change, or its host component.
export function createFirebaseSessionSync({ apply, isCurrentUser, onError = () => {} }) {
  let generation = 0;
  let disposed = false;
  return {
    invalidate() { generation++; },
    dispose() { disposed = true; generation++; },
    async sync(user) {
      if (disposed) return;
      const request = ++generation;
      if (!user) {
        apply(null, null);
        return;
      }
      try {
        const result = await user.getIdTokenResult();
        if (disposed || request !== generation || !isCurrentUser(user)) return;
        apply(result.token, new Date(result.expirationTime).getTime() - 5 * 60 * 1000);
      } catch {
        if (!disposed && request === generation && isCurrentUser(user)) onError();
      }
    },
  };
}
